// Co-Authored-By: AI-Assisted | updated: 2026-10-22 14:30:00
import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { buyersRouters } from './buyersRouters';
import { inviteRouters } from './inviteRouter';
import { supplierRouter } from './supplierCenterRouters';
import { companyRouter } from './companyRouter';

import { format_logistics_router_routes } from './logisticsRouter';
import { format_allocations_router_routes } from './allocationsRouter';

const Home = lazy(() => import('@/pages/home/index/index'));
const Login = lazy(() => import('@/pages/login/index'));
const Buyers = lazy(() => import('@/pages/buyers/index'));
const Invite = lazy(() => import('@/pages/invitePro/index'));
const SupplierCenter = lazy(() => import('@/pages/supplierCenter'));
const Company = lazy(() => import('@/pages/company/index/index'));
const Notice = lazy(() => import('@/pages/notice/index/index'));
const NoticeCompanyRelevance = lazy(() => import('@/pages/notice/company/relevance'));
const NotFound = lazy(() => import('@/pages/404'));
const Register = lazy(() => import('@/pages/register/index'));
const RegisterResult = lazy(() => import('@/pages/registerResult'));
const Retrieve = lazy(() => import('@/pages/retrieve/index'));
const ChangePassword = lazy(() => import('@/pages/changePassword/index'));
const School = lazy(() => import('@/pages/school/list'));
const SchoolItem = lazy(() => import('@/pages/school/detail'));
const SupplierApply = lazy(() => import('@/pages/supplierApply/index'));// 供应商申请
const Invitation = lazy(() => import('@/pages/supplierApply/invitation'));// 供应商申请
const InvitationResult = lazy(() => import('@/pages/supplierApply/invitationResult'));// 供应商结果
const ScisApply = lazy(() => import('@/pages/platform/scis/apply'));
const Apply = lazy(() => import('@/pages/apply/index'));
const Cart = lazy(() => import('@/pages/cart/index/index'));//购物车
const FavoritesList = lazy(() => import('@/pages/favorites/index/index'));//列表
const ProductSearch = lazy(() => import('@/pages/search'));//商品搜索
const ProductDetail = lazy(() => import('@/pages/product/detail'));
const PlanSubmit = lazy(() => import('@/pages/plan/submit/index'));
const PlanResult = lazy(() => import('@/pages/plan/result'));
const PlanList = lazy(() => import('@/pages/plan/list'));
const CartSubmit = lazy(() => import('@/pages/cart/submit/index'));
const CartResult = lazy(() => import('@/pages/cart/result/index'));
const DocumentPrint = lazy(() => import('@/pages/documents/components/Print/index'));
const UniDeliverOrder = lazy(() => import('../component/uniDeliverOrder/index'));
const AllocationIndex = lazy(() => import('@/pages/allocations/index/index'));
const ProductCommodity = lazy(() => import('@/pages/product/index/index'));
const AiINdex = lazy(() => import('@/pages/ai/index/index'));
const Risk = lazy(() => import('@/pages/risk'));
const CompanyApply = lazy(() => import('@/pages/company/change'));//公司申请信息变更
const InviteProInviteManagePrint = lazy(() => import('@/pages/invitePro/inviteManage/print'));
const ContractPerformancePrint = lazy(() => import('../pages/company/performance/print'));
const InviteResultPrint = lazy(() => import('../pages/supplierVerify/detail/index'));
const PlatformScisLogin = lazy(() => import('@/pages/platform/scis/login'));
const PlatformLogin = lazy(() => import('@/pages/platform/promotion/login'));


const routeConfig: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/documents/print',
    element: <DocumentPrint />,
  },
  {
    path: '/deliverorder/print',
    element: <UniDeliverOrder />,
  },
  {
    path: '/invite/print',
    element: <InviteProInviteManagePrint />,
  },
  {
    path: '/inviteResult/print',
    element: <InviteResultPrint />,
  },
  {
    path: '/company_contract_performance/print',
    element: <ContractPerformancePrint />,
  },
  {
    path: '/home',
    element: <Navigate to="/" replace />
  },
  {
    path: '/search',
    element: <ProductSearch />,
  },
  {
    path: '/productdetail/:org_id/:spu_id/:sku_id',
    element: <ProductDetail />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/ai',
    element: <AiINdex />
  },
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/registerResult',
    element: <RegisterResult />
  },
  {
    path: '/retrieve',
    element: <Retrieve />
  },
  {
    path: '/change-password',
    element: <ChangePassword />
  },
  {
    path: '/platform/promotion/login',
    element: <PlatformLogin />,
  },
  {
    path: '/platform/scis',
    children: [
      {
        path: '/platform/scis/apply',
        element: <ScisApply />,
      },
      {
        path: '/platform/scis/login',
        element: <PlatformScisLogin />,
      },
    ],
  },
  {
    path: '/apply',
    element: <Apply />,
  },
  {
    path: '/buyers',
    element: <Buyers />,
    children: buyersRouters,
  },
  {
    path: '/invite',
    element: <Invite />,
    children: inviteRouters,
  },
  {
    path: '/supplier',
    children: [
      {
        path: '/supplier/apply',
        element: <SupplierApply />,
      },
      {
        path: '/supplier/invitation',
        element: <Invitation />,
      },
      {
        path: '/supplier/invitationResult',
        element: <InvitationResult />,
      },
      {
        element: <SupplierCenter />,
        children: supplierRouter,
      },
    ],
  },
  {
    path: '/company',
    children: [
      {
        path: '/company/apply',
        element: <CompanyApply />,
      },
      {
        element: <Company />,
        children: companyRouter,
      },
    ],
  },
  {
    path: '/notice',
    element: <Notice />,
    children: [
      {
        index: true,
        element: <Navigate to="/notice/company_relevance" replace />,
      },
      {
        path: '/notice/company_relevance',
        element: <NoticeCompanyRelevance />,
        key: 'companyInfo',
        parentKey: 'companyManagement',
        label: 'Company Basic Information',
      },
    ],
  },
  {
    path: '/cart',
    element: <Cart />,
  },
  {
    path: '/favorites',
    element: <FavoritesList />,
  },
  {
    path: '/school/list',
    element: <School />
  },
  {
    path: '/school/item/:id',
    element: <SchoolItem />,
  },
  ...format_logistics_router_routes,
  {
    path: '/plan/submit',
    element: <PlanSubmit />,
  },
  {
    path: '/plan/result',
    element: <PlanResult />,
  },
  {
    path: '/plan/list',
    element: <PlanList />,
  },
  {
    path: '/cart/submit',
    element: <CartSubmit />,
  },
  {
    path: '/cart/result',
    element: <CartResult />,
  },
  {
    path: '/allocations',
    element: <AllocationIndex />,
    children: format_allocations_router_routes
  },
  {
    path: '/product/commodity',
    element: <ProductCommodity />,
    // children: format_allocations_router_routes
  },
  {
    path: '/risk/index',
    element: <Risk />,
  },
  {
    path: '/*',
    element: <NotFound />,
  }
];

export default routeConfig;